import React from "react";

export const Footer: React.FC = () => {
  return (
    <footer className="w-full bg-neutral-100">
      <div className="mx-auto max-w-360 px-5 py-6 md:px-39 md:py-10">
        <div className="flex flex-col gap-8 md:gap-6">
          {/* Logo + Links */}
          <div className="flex flex-col gap-8 md:flex-row md:items-center md:justify-between md:gap-0">
            <div className="flex items-end gap-4">
              <img src="/logo.png" alt="Bravo" className="h-8 md:h-10" />
              <span className="caption-regular text-black">by Ovation</span>
            </div>
            <div className="flex items-center gap-6">
              <a
                href="https://ovationventures.com/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="caption-regular hover:text-primary-500 text-neutral-800"
              >
                Privacy Policy
              </a>
              <a
                href="https://ovationventures.com/terms-of-use"
                target="_blank"
                rel="noopener noreferrer"
                className="caption-regular hover:text-primary-500 text-neutral-800"
              >
                Terms of Service
              </a>
            </div>
          </div>
          {/* Description */}
          <p className="caption-regular text-neutral-800 md:max-w-108">
            Bravo is designed and developed by{" "}
            <a
              href="https://ovationventures.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-primary-500 underline"
            >
              Ovation Ventures
            </a>
            , a fintech company crafting modern experiences for financial
            guidance.
          </p>
          {/* Copyright */}
          <p className="caption-regular text-neutral-800">
            &copy;2026 Ovation Ventures, Inc.
          </p>
        </div>
      </div>
    </footer>
  );
};
